////
/// ============================================================================
/// COMPONENT / Scroll To Top
/// ============================================================================
///
/// @group components
////

export default () => {

    let trigger = document.querySelector('.js-scroll-to-top');

    if (trigger) {
        let scrolling = false;
        let offset = trigger.dataset.offset || 200;

        trigger.addEventListener('click', function (event) {
            event.preventDefault();

            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });

        if (offset > 0) {
            window.addEventListener('scroll', function () {
                if (!scrolling) {
                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(handleVisibility);
                    } else {
                        setTimeout(handleVisibility, 250);
                    }

                    scrolling = true;
                }
            });
        }

        function handleVisibility() {
            let top = window.scrollY || document.documentElement.scrollTop;
            trigger.classList.toggle('-visible', top >= offset);
            scrolling = false;
        }

        handleVisibility();
    }

};
